// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bMaN","right":"styles_right__1TbKX"};